import { render, staticRenderFns } from "./ForgotPasswordLayout.vue?vue&type=template&id=55f19877&scoped=true&"
import script from "./ForgotPasswordLayout.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f19877",
  null
  
)

export default component.exports